import { useCallback, useEffect, useRef, useState } from 'react';

// 本地倒计时 Hook：
// - 每一步 stepKey 变化（教练完成一次 ban/pick）就重置回 stepSeconds 重新倒数
// - togglePause() 暂停时秒数定格，恢复时从定格点继续
// - 完成（isFinished=true）则停止倒计时，固定显示 0
const useCoachTimer = ({ stepKey, stepSeconds, isFinished }) => {
  const [secondsLeft, setSecondsLeft] = useState(stepSeconds);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const clearTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // 每次切换到新一步，重置秒数
  useEffect(() => {
    setSecondsLeft(stepSeconds);
  }, [stepKey, stepSeconds]);

  // 启停定时器
  useEffect(() => {
    clearTimer();
    if (isPaused || isFinished) return undefined;

    intervalRef.current = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    return clearTimer;
  }, [isPaused, isFinished, stepKey]);

  const togglePause = useCallback(() => {
    if (isFinished) return;
    setIsPaused((p) => !p);
  }, [isFinished]);

  const resetTimer = useCallback(() => {
    setSecondsLeft(stepSeconds);
    setIsPaused(false);
  }, [stepSeconds]);

  return { secondsLeft, isPaused, togglePause, resetTimer };
};

export default useCoachTimer;
